/** @format */
const getPropertyTypeTranslation = (value, translation) => {
  return translation[value];
};

export default getPropertyTypeTranslation;
